import { ProgressionTemplate, ProgressionTemplateFromApi, ProgressionTemplateRequest } from "./types";

export const transformProgressionTemplate = (t: ProgressionTemplateFromApi): ProgressionTemplate => ({
  id: t.id,
  name: t.name,
  numWeeks: t.numWeeks,
  idContainer: t.idContainer,
  weeks: (t.weeks || [])
    .sort((a, b) => a.weekNumber - b.weekNumber)
    .map((w) => ({
      weekNumber: w.weekNumber,
      sets: (() => {
        try {
          return JSON.parse(w.setsData || "[]");
        } catch {
          return [];
        }
      })(),
      notes: w.notes || "",
    })),
});

export const transformProgressionTemplates = (
  data: ProgressionTemplateFromApi[]
): ProgressionTemplate[] => data.map(transformProgressionTemplate);

export const toProgressionTemplateRequest = (
  template: Omit<ProgressionTemplate, "id"> & { id?: number }
): ProgressionTemplateRequest => ({
  id: template.id,
  name: template.name,
  numWeeks: template.numWeeks,
  idContainer: template.idContainer,
  weeks: template.weeks.map((w) => ({
    weekNumber: w.weekNumber,
    setsData: JSON.stringify(w.sets),
    notes: w.notes || "",
  })),
});

export const searchProgression = (
  templates: ProgressionTemplate[],
  searchValue: string,
  setSearchInput: (value: string) => void,
  setFilteredResults: (value: ProgressionTemplate[]) => void
) => {
  setSearchInput(searchValue);
  if (searchValue !== "") {
    const filtered = templates.filter((t) =>
      t.name.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredResults(filtered);
  } else {
    setFilteredResults(templates);
  }
};

/** Parses a reps string like "10" or "10-12" into {reps, repsRange} */
export const parseRepsInput = (input: string): { reps: number; repsRange?: number } => {
  const trimmed = input.trim();
  if (trimmed.includes("-")) {
    const parts = trimmed.split("-");
    const min = parseInt(parts[0], 10);
    const max = parseInt(parts[1], 10);
    if (!isNaN(min) && !isNaN(max)) {
      return { reps: min, repsRange: max };
    }
  }
  const n = parseInt(trimmed, 10);
  return { reps: isNaN(n) ? 0 : n };
};

/** Formats {reps, repsRange} to display string "10" or "10-12" */
export const formatRepsDisplay = (reps: number, repsRange?: number): string => {
  if (repsRange && repsRange !== reps) {
    return `${reps}-${repsRange}`;
  }
  return `${reps}`;
};
